import { Suspense, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';

import ForceAuth from '@/components/auth/ForceAuth';
import { Loading } from '@/components/ui/daisy/loading';
import { FocusFrameContext } from '@/data/context/FocusFrameContext';

export default function AppShellFocusFrame() {
  const [hasMountedLayout, setHasMountedLayout] = useState(false);
  const focusFrame = useMemo(
    () => ({ hasMountedLayout, setHasMountedLayout }),
    [hasMountedLayout],
  );

  return (
    <ForceAuth>
      <div
        data-testid="appShellFocusFrame"
        className="h-screen w-screen overflow-hidden bg-base-200"
      >
        <Suspense
          fallback={
            <div className="flex h-full items-center justify-center">
              <Loading color="primary" size="lg" />
            </div>
          }
        >
          <FocusFrameContext.Provider value={focusFrame}>
            <Outlet />
          </FocusFrameContext.Provider>
        </Suspense>
      </div>
    </ForceAuth>
  );
}
